module.exports = __webpack_public_path__ + "img/img23.25b4607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img23.jpg
// module id = 320
// module chunks = 0